import { __awaiter, __generator } from "tslib";
import Mitt from 'mitt';
import { call } from './call';
var mitt = Mitt();
var initPromise = new Promise(function (resolve) {
    setTimeout(function () {
        resolve(true);
    }, 1000);
});
var callback = function (params) {
    var eventName = params.eventName, data = params.data;
    var res = { eventName: eventName, data: data };
    mitt.emit(eventName, res);
};
export var on = function (eventName, handler) { return __awaiter(void 0, void 0, void 0, function () {
    var handlerList;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, initPromise];
            case 1:
                _a.sent();
                handlerList = mitt.all.get(eventName);
                if (handlerList === null || handlerList === void 0 ? void 0 : handlerList.includes(handler))
                    return [2 /*return*/];
                if (!(handlerList === null || handlerList === void 0 ? void 0 : handlerList.length))
                    call('SKMessage', 'register', callback, { eventName: eventName });
                mitt.on(eventName, handler);
                return [2 /*return*/];
        }
    });
}); };
export var off = function (eventName, handler) { return __awaiter(void 0, void 0, void 0, function () {
    var handlerList;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, initPromise];
            case 1:
                _a.sent();
                mitt.off(eventName, handler);
                handlerList = mitt.all.get(eventName);
                if (!(handlerList === null || handlerList === void 0 ? void 0 : handlerList.length))
                    call('SKMessage', 'unregister', function () { }, { eventName: eventName });
                return [2 /*return*/];
        }
    });
}); };
export var emit = function (eventName, params) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, initPromise];
            case 1:
                _a.sent();
                call('SKMessage', 'sendMessage', { eventName: eventName, data: params || {} });
                return [2 /*return*/];
        }
    });
}); };
